import { useEffect, useState } from 'react';

const useWidth = (actions: HTMLDivElement, actionsInner: HTMLDivElement) => {
  const [actionsWidth, setActionsWidth] = useState<number>(0);
  const [actionsInnerWidth, setActionsInnerWidth] = useState<number>(0);

  useEffect(() => {
    if (!actions || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setActionsWidth(entry.contentRect.width);
      });
    });
    resizeObserver.observe(actions);

    return () => {
      resizeObserver.disconnect();
    };
  }, [actions]);

  useEffect(() => {
    if (!actionsInner || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setActionsInnerWidth(entry.contentRect.width);
      });
    });
    resizeObserver.observe(actionsInner);

    return () => {
      resizeObserver.disconnect();
    };
  }, [actionsInner]);

  return {
    actionsWidth,
    actionsInnerWidth,
  };
};

export { useWidth };
